import React from "react";
import { css } from "@emotion/core";

import {
  Modal,
  ModalContent,
  ModalContentHeader,
  ModalContentBody,
  ModalContentFooter,
  Text,
  Button,
  Link,
  Alert,
  Margin,
} from "@zapier/design-system";

export const PaymentIntentFatalErrorModal = () => {
  return (
    <Modal
      ariaLabel="Error in checkout modal"
      canClose={false}
      onClosed={() => {}}
    >
      <ModalContent>
        <ModalContentHeader align="center">
          <Text type="paragraph1Bold">Something went wrong</Text>
        </ModalContentHeader>
        <ModalContentBody align="center">
          <Text>
            We're having some trouble with checkout at the moment. Please reload
            the page and try again.
          </Text>
        </ModalContentBody>
        <ModalContentFooter>
          <Button onClick={() => window.location.reload()} size="small">
            Reload page
          </Button>
        </ModalContentFooter>
      </ModalContent>
    </Modal>
  );
};

const descriptionStyles = css`
  &:last-child {
    margin-bottom: 0;
  }
`;

type RetryPaymentIntentAlertProps = {
  retry: () => void;
};

export const RetryPaymentIntentAlert = (
  props: RetryPaymentIntentAlertProps
) => {
  return (
    <Margin margin="2em 0 0 0">
      <Alert title="Something went wrong" type="error">
        <p css={descriptionStyles}>
          We couldn't verify your payment attempt. Please try again or reload
          the page.{" "}
          <Link onClick={props.retry} role="link">
            Retry
          </Link>
        </p>
      </Alert>
    </Margin>
  );
};
